import React, { useEffect, useState } from "react";
import "./styles.css";

export const handler = ({ inputs, mechanic }) => {
  const { width, height, image, imageAlignment } = inputs;

  const finalWidth = width;
  const finalHeight = height;

  const [imageUrl, setImageUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Handle image loading
  useEffect(() => {
    if (image) {
      const url = typeof image === "string" ? image : URL.createObjectURL(image);
      setImageUrl(url);
      
      // Preload image before marking as done
      const img = new Image();
      img.onload = () => setIsLoading(false);
      img.onerror = () => setIsLoading(false);
      img.src = url;
      
      return () => {
        if (typeof image !== "string") {
          URL.revokeObjectURL(url);
        }
      };
    } else {
      setImageUrl(null);
      setIsLoading(false);
    }
  }, [image]);

  // Only call done() after image is loaded
  useEffect(() => {
    if (!isLoading) {
      mechanic.done();
    }
  }, [isLoading]);

  return (
    <div
      className="image-layout-container"
      style={{
        width: `${finalWidth}px`,
        height: `${finalHeight}px`,
        backgroundColor: "#fcf3c2",
        display: "flex",
        justifyContent: imageAlignment === "right" ? "flex-end" : "flex-start",
        alignItems: "flex-end",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          style={{
            width: "90%",
            height: "auto",
            maxHeight: "95%",
            objectFit: "cover",
            boxSizing: "border-box",
          }}
        />
      )}
    </div>
  );
};

export const inputs = {
  width: {
    type: "number",
    default: 1080,
    label: "Width",
  },
  height: {
    type: "number",
    default: 1350,
    label: "Height",
  },
  image: {
    type: "image",
  },
  imageAlignment: {
    type: "text",
    default: "left",
    options: ["left", "right"],
    label: "Image Alignment",
  },
};

export const presets = {
  vertical: {
    width: 1080,
    height: 1350,
  },
  square: {
    width: 1080,
    height: 1080,
  },
  landscape: {
    width: 1080,
    height: 566,
  },
  story: {
    width: 1080,
    height: 1920,
  },
};

export const settings = {
  engine: require("@mechanic-design/engine-react"),
  name: "Image Layout",
  persistRandomOnExport: true,
  hidePresets: false,
  hideAutoRefresh: true,
  ignoreStyles: false,
  // hideScaleToFit: true,
};
